import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const notifyAttachmentViewed = (fileId: string) => {
	try {
		const url = '/rest/internal/3/analytics/attachment/viewed';
		return performPostRequest(url, {
			body: JSON.stringify({ fileId }),
		});
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'notifyAttachmentViewed',
				packageName: 'jiraAttachmentViewedStreamhubEvents',
				teamName: 'gryffindor',
			},
		});
	}
};
